<template>
  <van-popup v-model="show" position="bottom" @close="close">
    <div class="area-pickers">
      <van-area class="common-area" :columns-num="columnNum" :area-list="areaList" @confirm="chooseAreaItem" @cancel="close" />
    </div>
  </van-popup>
</template>

<script>
import AreaList from '../utils/area'
export default {
  props: {
    areaPickerVisible: { type: Boolean, default: false },
    columnNum: { type: Number, default: 3 },
  },
  data() {
    return {
      show: false,
      selectItem: null,
      areaList: AreaList,
    }
  },
  watch: {
    areaPickerVisible(val) {
      if (val) {
        this.show = val;
      }
    },
    show(val) {
      this.$emit('chooseAreaItem', this.selectItem, val);
    },
  },
  methods: {
    close() {
      this.show = false;
    },
    chooseAreaItem(val) {
      this.show = false;
      this.selectItem = val;
    },
  },
}
</script>
<style lang="less">
	.area-pickers {
		.van-hairline--top-bottom::after {
			border-width: 2px;
		}
		.common-area .van-picker__toolbar {
			height: 90px;
			line-height: 90px;
			&.van-hairline--top-bottom::after {
				border-width: 0;
			}
			.van-picker__cancel, .van-picker__confirm {
				font-size: 36px;
				padding: 0 60px;
				color:#2c3e50;
			}
			.van-picker__confirm{
				color: rgb(255, 102, 8);
			}
		}
	}
</style>
